var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFishing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fishing-Line--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fishing Line Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.67a0.24 0.24 0 0 1 -0.08 -0.34c1.41 -2.31 2.8 -6 0.54 -7.5 -1.27 -0.82 -3.41 -0.38 -5 2.08 -1.76 2.66 -3.57 3.25 -4.29 2.81s-1.1 -2.48 0.9 -6.2c1.49 -2.78 1.65 -5.16 0.44 -6.53A3.55 3.55 0 0 0 9.42 0.35c-4.52 1.77 -7 8.06 -7.5 14.1a0.9 0.9 0 0 0 0.23 0.68 0.92 0.92 0 0 0 0.66 0.29 0.49 0.49 0 0 1 0.49 0.49 0.51 0.51 0 0 1 -0.51 0.51h-0.74a0.72 0.72 0 0 0 -0.75 0.67v5.06C1.3 23.5 2 24 2.8 24s1.5 -0.5 1.5 -1.85V18a3 3 0 1 0 2 -5.22 2.93 2.93 0 0 0 -1.83 0.64 0.24 0.24 0 0 1 -0.28 0 0.26 0.26 0 0 1 -0.13 -0.25C5 6.16 8.25 3 10.15 2.22c0.83 -0.33 1.53 -0.29 1.87 0.1s0.54 1.93 -0.7 4.25c-2.7 5 -1.85 7.86 -0.17 8.87s4.51 0.32 7 -3.43c0.88 -1.34 1.91 -1.73 2.27 -1.5s0.67 1.91 -1.3 5a2.09 2.09 0 0 0 0.94 2.88 1 1 0 0 0 1.34 -0.51 1 1 0 0 0 -0.4 -1.21ZM6.3 14.75a1 1 0 1 1 -1 1 1 1 0 0 1 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFishing);
export default ForwardRef;